import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../../ui/Dialog/DialogActions";
import Checkbox from "../../../../../../../../ui/Checkbox";
import AddEmployeeForm from "./AddEmployeeForm";
import Button from "../../../../../../../../ui/Button";

const styles = theme => ({
  dialog: {
    width: "550px"
  }
});

const CreateNew = ({
  open,
  handleClose,
  createRoom,
  isCreatingRoom,
  orgName,
  createdRoom,
  classes,
  history
}) => {
  const [checked, setChecked] = React.useState(false);
  const [formData, updateFormData] = React.useState(null);

  const onConfirm = () => {
    createRoom(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  // React.useEffect(() => {
  //   if (createdRoom && createdRoom.success) {
  //     updateFormData(null);
  //     handleClose();

  //     if (checked) {
  //       history.push(`/work/app/organization/${createdRoom.id}`);
  //     }
  //   }
  // }, [createdRoom]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}>
        <DialogTitle onClose={onClose}>{`Добавить сотрудника в организацию ${orgName}`}</DialogTitle>
        <DialogContent>
          <AddEmployeeForm
            onFormChange={updateFormData}
            disabled={isCreatingRoom}
          />
        </DialogContent>
        <DialogActions>
          <Checkbox
            label="Открыть форму для редактирования"
            checked={checked}
            handleChange={() => setChecked(!checked)}
            value="checked"
            color="primary"
          />
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingRoom}
            disabled={isCreatingRoom}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(CreateNew));
